import * as METADATA_KEY from "../constants/metadata_keys";
import { injectBase } from "./inject_base";
var multiInject = injectBase(METADATA_KEY.MULTI_INJECT_TAG);
export { multiInject };
//# sourceMappingURL=multi_inject.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/inversify/es/annotation/multi_inject.js
// module id = 1736
// module chunks = 0